import { IbrowserInfo, getBrowserInfo } from '@utils/browserInfo';
import { isMobile } from 'react-device-detect';
const invalidBrowsers = [
  {
    name: 'Chrome Mobile',
    osName: 'Android',
    version: 125,
  },
  {
    name: 'Chrome',
    version: 85,
  },
  {
    name: 'Edge',
    version: 85,
  },
  {
    name: 'Safari',
    version: 14,
  },
  {
    name: 'Firefox',
    version: 79,
  },
  {
    name: 'Opera',
    version: 71,
  },
];

export const browserIsValidForBiometric = (
  browser: IbrowserInfo = getBrowserInfo(),
) => {
  if (
    browser.name === 'Chrome Mobile' &&
    browser.osName == 'Android' &&
    parseInt(browser.version) < 125
  ) {
    return false;
  }

  if (
    invalidBrowsers.some(
      (invalidBrowser) =>
        invalidBrowser.name === browser.name &&
        (!invalidBrowser.version ||
          parseInt(browser.version) < invalidBrowser.version),
    ) ||
    !isMobile
  ) {
    return false;
  }

  return true;
};
